import { useState, useEffect, forwardRef, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from '@teo/components';

import { axios } from '@/axios';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { config } from '@/config';
import UserTab from './AddFollowers/UserTab';
import TeamTab from './AddFollowers/TeamTab';
import EvaluatorsTab from './AddFollowers/EvaluatorsTab';

const AddFollowersStep = forwardRef(
  (
    {
      state,
      teamInfo,
      student,
      setLoadStep,
      courseType,
      currentUsers,
      setCurrentUsers,
      currentTeams,
      setCurrentTeams,
      currentTeachers,
      setCurrentTeachers,
      setDelUsers,
      setDelTeams,
      setDelTeachers,
      loadedStep,
    }: any,
    ref
  ) => {
    const {
      newUsers,
      newTeachers,
      setNewTeachers,
      setNewUsers,
      newTeams,
      setNewTeams,
    } = state;
    const { t } = useTranslation();
    const { auth } = useContext(AuthContext);
    const authUser = auth?.user;

    const [tab, setTab] = useState('users');
    const [value, setValue] = useState<any>([]);
    const [newTeamUser, setNewTeamUser] = useState<any>([
      ...newTeams,
      ...newUsers,
    ]);

    const [reportSubteams, setReportSubteams] = useState<boolean>(false);

    const [teachers, setTeachers] = useState<any>([]);

    useEffect(() => {
      const addTeamUser = [...newTeamUser];
      if (teamInfo) {
        const existingObj = addTeamUser.find(
          (team) => team?.id === teamInfo?.id
        );
        if (!existingObj) {
          addTeamUser.push({
            key: teamInfo?.id,
            id: teamInfo?.id,
            name: teamInfo?.teamName,
            teamId: teamInfo?.id,
            label: teamInfo?.teamName,
            organisationId: teamInfo?.organisationId,
            color: teamInfo?.color,
            isTeam: true,
          });
        }
      }
      if (student) {
        const existingObj = addTeamUser.find(
          (user) => user?.id === student?.id
        );
        if (!existingObj) {
          addTeamUser.push({
            key: student?.id,
            name: student?.username,
            id: student?.id,
            userId: student?.id,
            label: student?.username,
            organisationId: student?.organisationId,
            isTeam: false,
          });
        }
      }
      setNewTeamUser(addTeamUser);
      setTimeout(() => {
        setLoadStep(false);
        loadedStep();
      }, 100);
    }, []);

    useEffect(() => {
      setNewTeams(newTeamUser.filter((team: any) => team.teamId));
      setNewUsers(newTeamUser.filter((usr: any) => usr.userId));
    }, [newTeamUser]);

    const handleAddUserToList = async (newValue: any) => {
      const addTeam = [...newTeamUser];
      for (const obj2 of newValue) {
        const existingObj = addTeam.find(
          (obj1) =>
            (obj1?.userId && obj1?.userId === obj2?.userId) ||
            (obj1?.teamId && obj1?.teamId === obj2?.teamId)
        );
        if (!existingObj) {
          if (obj2?.teamId && reportSubteams) {
            const teamInfo: any = await axios.get(
              `${config.backend}/team/${obj2?.organisationId}/${obj2?.teamId}`
            );
            const subTeams: any = await axios.get(
              `${config.backend}/teams?organisationId=${
                obj2?.organisationId
              }&searchPath=${encodeURIComponent(
                teamInfo?.data?.teamPath + '%'
              )}&sort=teamPath`
            );
            if (subTeams?.data && subTeams?.data?.length > 0) {
              const teamSubteams = subTeams?.data;
              for (const sub of teamSubteams) {
                const existingTeam = addTeam.find(
                  (obj1) => obj1?.teamId && obj1?.teamId === sub?.id
                );
                const existingTeam_2 = newTeamUser.find(
                  (obj1: any) => obj1?.teamId && obj1?.teamId === sub?.id
                );
                if (!existingTeam && !existingTeam_2) {
                  addTeam.push({
                    courseId: null,
                    isMember: false,
                    isTeam: true,
                    color: sub?.color,
                    key: `${sub?.id}_null_email`,
                    label: sub?.teamName,
                    name: sub?.teamName,
                    organisationId: sub?.organisationId,
                    teamId: sub?.id,
                    userId: null,
                  });
                }
              }
            }
          } else {
            if (obj2.teamId) obj2.isTeam = true;
            const newItem = Object.assign({}, obj2, {
              isTeam: obj2.teamId ? true : false,
              isMember: obj2.userId ? true : false,
              color: obj2?.color,
              label: obj2?.name || obj2?.email,
            });
            addTeam.push(newItem);
          }
        }
      }
      setNewTeamUser(addTeam);
      setValue([]);
    };

    const handleAddTeacherToList = (newValue: any) => {
      const newNewTeachers = newTeachers.slice();
      for (const teacher of newValue) {
        const found = newTeachers.find(
          (oldTeacher: any) => teacher.key === oldTeacher.key
        );
        if (!found) {
          newNewTeachers.push(teacher);
        }
      }
      setNewTeachers(newNewTeachers);
      setTeachers([]);
    };

    const handleRemove = (id: any) => {
      const removeTeam = newTeamUser.filter((item: any) => item.key !== id);
      setNewTeamUser(removeTeam);
    };

    const handleRemoveTeacher = (id: any) => {
      const removeTeacher = newTeachers.filter((item: any) => item.key !== id);
      setNewTeachers(removeTeacher);
    };

    return (
      <div>
        {authUser?.activeOrganisationRole &&
          authUser?.activeOrganisationRole >= 40 && (
            <>
              <article className="prose flex flex-col ">
                <h3 className="text-base">
                  {t('pages.course_content_flow.step_1.title_add')}
                </h3>
                <p className="pt-3 text-sm text-grey-07">
                  {courseType !== 'learning-path'
                    ? t('pages.course_content_flow.step_1.subtitle')
                    : t('pages.course_content_flow.step_1.subtitle_lp')}
                </p>
              </article>
              <div className="mt-6 flex flex-col lg:flex-row">
                <Tabs activeName={tab} onChange={(tab) => setTab(tab)}>
                  <div className="flex gap-2">
                    <Tabs.TabButton name="users">
                      <p className="text-base font-medium">
                        {t('columns.students')}
                      </p>
                    </Tabs.TabButton>
                    <Tabs.TabButton name="teams">
                      <p className="text-base font-medium">
                        {t('links.teams')}
                      </p>
                    </Tabs.TabButton>
                    {courseType !== 'instruction' &&
                      courseType !== 'learning-path' && (
                        <Tabs.TabButton name="evaluators">
                          <p className="text-base font-medium">
                            {t('pages.follow_up_courses.teachers')}
                          </p>
                        </Tabs.TabButton>
                      )}
                  </div>
                </Tabs>
              </div>
              <div className="mt-1">
                {tab === 'teams' && (
                  <TeamTab
                    authUser={authUser}
                    setValue={setValue}
                    value={value}
                    handleAddUserToList={handleAddUserToList}
                    newTeamUser={newTeamUser}
                    newTeams={newTeams}
                    setNewTeamUser={setNewTeamUser}
                    handleRemove={handleRemove}
                    setReportSubteams={setReportSubteams}
                    reportSubteams={reportSubteams}
                    setCurrentTeams={setCurrentTeams}
                    currentTeams={currentTeams}
                    setCurrentUsers={setCurrentUsers}
                    currentUsers={currentUsers}
                    setDelUsers={setDelUsers}
                    setDelTeams={setDelTeams}
                  />
                )}
                {tab === 'users' && (
                  <UserTab
                    authUser={authUser}
                    setValue={setValue}
                    value={value}
                    handleAddUserToList={handleAddUserToList}
                    newUsers={newUsers}
                    handleRemove={handleRemove}
                    setCurrentUsers={setCurrentUsers}
                    currentUsers={currentUsers}
                    setDelUsers={setDelUsers}
                  />
                )}
                {tab === 'evaluators' && (
                  <EvaluatorsTab
                    authUser={authUser}
                    value={value}
                    handleAddTeacherToList={handleAddTeacherToList}
                    handleRemoveTeacher={handleRemoveTeacher}
                    setTeachers={setTeachers}
                    teachers={teachers}
                    newTeachers={newTeachers}
                    currentTeachers={currentTeachers}
                    setCurrentTeachers={setCurrentTeachers}
                    setDelTeachers={setDelTeachers}
                  />
                )}
              </div>
            </>
          )}
      </div>
    );
  }
);

AddFollowersStep.displayName = 'AddUserTeamStep';

export default AddFollowersStep;
